/**
 * Places drawer form — open/close for .marsh-image-with-text-form
 */
(function () {
  function openDrawer(id) {
    var drawer = document.querySelector('.drawer-form-places[data-drawer-id="' + id + '"]');
    var overlay = document.querySelector('.drawer-overlay-places[data-drawer-id="' + id + '"]');
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.style.transform = 'translateX(0)';
    overlay.classList.add('is-open');
    overlay.style.display = 'block';
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer(id) {
    var drawer = document.querySelector('.drawer-form-places[data-drawer-id="' + id + '"]');
    var overlay = document.querySelector('.drawer-overlay-places[data-drawer-id="' + id + '"]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.style.transform = 'translateX(100%)';
    }
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.style.display = 'none';
    }
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('.open-drawer-btn');
    if (open) {
      e.preventDefault();
      openDrawer(open.dataset.drawerId);
      return;
    }

    var close = e.target.closest('.close-drawer-btn');
    if (close) {
      e.preventDefault();
      closeDrawer(close.dataset.drawerId);
      return;
    }

    var overlayClick = e.target.closest('.drawer-overlay-places');
    if (overlayClick) {
      closeDrawer(overlayClick.dataset.drawerId);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openDrawerEl = document.querySelector('.drawer-form-places.is-open');
    if (!openDrawerEl) return;
    closeDrawer(openDrawerEl.dataset.drawerId);
  });
})();
